// extracted by mini-css-extract-plugin
export default {"payLink":"personal-alert_payLink__Mxgt8"};